import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const abAdminUserListRBAC = {
  pageID: '11505bcb3129b7f68768d6faec9b715d',
  elementID: {
    ViewPage: '7b8747508c9afe726601a58b3d132c3e',
    Detail: '6018916899490293743d47299eb8e95a',
    Unwhitelist: '471bce0472e6b34914340249af86c95b',
  },
} as const

export const useRBACAbAdminUserListPage = createUseRBAC(abAdminUserListRBAC.elementID)

export type UseRBACAbAdminUserListPageType = ReturnType<typeof useRBACAbAdminUserListPage>
